import React, { useMemo } from 'react';
import { Box, Inscription, ListItem, ListItemBase } from '@common-fe/common-fe';

import TransactionsListHeader from '@/modules/transaction/TransactionsList/TransactionsListHeader/TransactionsListHeader';

import { PlansCoveragesDatesErrors } from './hooks/usePlansCoveragesDatesValidation';
import { TerminationPlanListItem } from './TerminationPlanListItem';

const headers: ListItemBase[] = [
  {
    key: 'planName',
    title: 'Plans',
    flex: 1.7,
  },
  {
    key: 'endOfCoverage',
    title: 'End of coverage',
    flex: 1.1,
  },
  {
    key: 'lastDayToSubmitClaim',
    title: 'Last day to submit claim',
    flex: 1,
  },
];

interface ErrorBoxProps {
  planId: string;
  planCoveragesErrors: PlansCoveragesDatesErrors;
}

const ErrorBox: React.FC<ErrorBoxProps> = ({
  planId,
  planCoveragesErrors,
}) => {
  const planErrors = useMemo(() => {
    const errors = [planCoveragesErrors?.claimLastDateErrorText, planCoveragesErrors?.invalidPlanCoverageDateErrorText]
      .filter((error) => !!error);
    return errors.length > 0 ? errors : undefined;
  }, [planCoveragesErrors]);

  if (!planErrors) return null;

  return (
    <>
      {planErrors.map((error, index) => (
        <Box
          key={`${planId}_error_${error}_${index}`}
          data-testid="EmployerTerminationPlansCoverageDatesList_errorBox"
          margin={{ top: 'spacing4' }}
        >
          <Inscription
            size="14px"
            color="danger"
            textAlign="start"
            lineHeight='20px'
          >
            {error}
          </Inscription>
        </Box>
      ))}
    </>
  );
}
  

interface Props {
  planList: ListItem[];
  withEdit?: boolean;
  planCoveragesErrors?: PlansCoveragesDatesErrors[];
}

export const EmployerTerminationPlansCoverageDatesList: React.FC<Props> = ({
  planList,
  withEdit,
  planCoveragesErrors,
}) => {
  return (
    <Box
      data-testid="EmployerTerminationPlansCoverageDatesList_container"
      round="container1Round"
      background="canvas"
      pad="spacing24"
      border={{ color: 'border2' }}
    >
      <Box
        justify="center"
        height={{ min: '40px', max: '40px'}}
        margin={{ bottom: 'spacing16' }}
      >
        <Inscription size="20px">
          Termination Coverage Dates
        </Inscription>
      </Box>

      <Box data-testid="EmployerTerminationPlansCoverageDatesList_table">
        <TransactionsListHeader
          items={headers}
          style={{
            paddingInline: '12px',
            paddingBlock: '6px',
            marginBottom: '8px',
            borderRadius: '8px',
          }}
        />

        {planList.map((item, i) => (
          <>
            <TerminationPlanListItem
              key={item.id}
              fields={item.fields}
              id={item.id}
            />

            {planCoveragesErrors && planCoveragesErrors[i] && (
              <ErrorBox
                planId={item.id}
                planCoveragesErrors={planCoveragesErrors[i]}
              />
            )}

            {withEdit && i < planList.length - 1 && (
              <Box
                width="100%"
                height="1px"
                background={{ color: 'border2'}}
                margin={{ vertical: 'spacing8' }}
              />
            )}
          </>
        ))}

      </Box>
    </Box>
  );
};
